// 全局配置host，其中__MAIN_ORIGIN__为兼容mdf的全局host配置，一般在非统一域名、本地调试等跨域场景下引用tnsSdk.js需配置。
window.TNS_BASE_HOST = window.TNS_BASE_HOST || window.__MAIN_ORIGIN__ || '';
export {asyncImport3rd} from "./load3nd";
// git版本号
const version = process.env.COMMIT_LAST_DATE;
export {version};
// import "./xsrf_check";
import './loadPolyfill.js';
export {asyncProjectContext, projectName2ContextPath, asyncUrl2ProjectName} from '../context';
export {asyncLoadPackage,asyncLoadComponent,asyncImport,asyncSinglePackageInfo,loadRemoteScript, asyncGetPackageMetaInfo} from '../load2nd';
import  "tne-core-fe/i18n/i18n.umd.js";

import {CookieHelper, secondDomain} from '../xscf';
export {writeXscfToken,readXscfToken,generateUriToken,getRelativeURL,isAbsoluteURL} from '../xscf';
import MicroSystemRun from '../MicroSystemRuntime';
const microSystemInstance = new MicroSystemRun();
// 获取单例的微应用系统
export function getMicroSystem(){
    return microSystemInstance;
}
// 获取事件代理对象
export function getEventProxy(providerName){
    if(!providerName)throw new Error(`getEventProxy方法缺少必要参数：providerName`);
    return microSystemInstance.getProviderEventProxy(providerName);
}
//暂时去掉
// luaApi.asyncFetchProjectVersions();
export {MainApplication,SmallApplication,SwitchApplication,ComponentLoader} from '../react/index'
const setDebug = () => {
    const location = window.location;
    if (location?.href?.includes('debug=true')) {
        let nowTime = new Date().getTime();
        let domain  = secondDomain(location.hostname);
        if (domain.includes('.yyuap.com')) {
            domain = '.yonyoucloud.com';
        }
        let config = {path: '/', expires: nowTime + 8 * 60 * 60 * 1000, domain};// cookie值有效期8小时
        if (location.protocol == 'https:') {
            config.secure = true;
            config.samesite = 'None';
        }
        CookieHelper.write('debug', true, config);
    }
};
setDebug();

// try {
//     if (typeof window.React !== "undefined") {
//         import("../../static/react/18.3.1/cjs/react-jsx-runtime.production.min.js").then(
//             ({ jsx, jsxs }) => {
//                 window.React.jsx = jsx;
//                 window.React.jsxs = jsxs;
//             }
//         );
//     }
// } catch (error) {
//     console.log(error);
// }